import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    }
});
export default stylesheet;
